module.exports = __webpack_public_path__ + "static/img/true-money-icon.e1a71ea2.png";